import { Tagging } from '@empathy/search-types';
import { DiscoveryWallState } from '../../../models';
import { DISCOVERY_WALL_GETTERS_KEYS } from '../discovery-wall.const';
import { DiscoveryWallGetter } from '../discovery-wall.interfaces';

export class DiscoveryWallTrackingGetter implements DiscoveryWallGetter {
  getters = {
    [DISCOVERY_WALL_GETTERS_KEYS.clicksShowTracking]: (state: DiscoveryWallState): Tagging => state.clicksRecommendations.showTagging,
    [DISCOVERY_WALL_GETTERS_KEYS.queriesShowTracking]: (state: DiscoveryWallState): Tagging => state.queriesRecommendations.showTagging,
    [DISCOVERY_WALL_GETTERS_KEYS.sectionShowTracking]: (state: DiscoveryWallState): Tagging => state.sectionRecommendations.showTagging,
    [DISCOVERY_WALL_GETTERS_KEYS.userShowTracking]: (state: DiscoveryWallState): Tagging => state.userRecommendations.showTagging
  };
}
